/* eslint-disable no-underscore-dangle */
const {
  isPlainObject
} = require('lodash');
const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate arrayFilterBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const logCollection = await evaluateSource(source.value, content, parentContentPath, transientContext, nativeFunctions);
  let fullLog = await evaluateSource(source.fullLog, content, parentContentPath, transientContext, nativeFunctions);
  if (fullLog !== false) {
    fullLog = true;
  }
  if (logCollection === undefined || !isPlainObject(logCollection)) {
    return undefined;
  }
  const sortedKeys = Object.keys(logCollection).sort((a, b) => new Date(logCollection[b]._created) - new Date(logCollection[a]._created));
  let done = false;
  for (let i = 0; i < sortedKeys.length && !done; i += 1) {
    const key = sortedKeys[i];
    const log = logCollection[key];
    const {
      contentPath,
      breadcrumbs,
      previousCreatedDate
    } = log;
    if (fullLog === false && previousCreatedDate !== undefined) {
      // we are done - we have already processed the rest of these.
      done = true;
    } else if (i + 1 < sortedKeys.length) {
      // find the most recent log prior to this log        previousCreatedDate = null;
      let found = false;
      for (let j = i + 1; j < sortedKeys.length && !found; j += 1) {
        const findKey = sortedKeys[j];
        const testLog = logCollection[findKey];
        if (testLog.contentPath === contentPath && testLog.breadcrumbs === breadcrumbs) {
          found = true;
          // found it!
          log.previousCreatedDate = testLog._created;
          log.previousValue = testLog.value;
          log.previousDisplayValue = testLog.displayValue;
        }
      }
    }
  }
  return logCollection;
};
module.exports = {
  evaluate
};